<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import VideoPlayer from '@/components/ui/VideoPlayer.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  description,
  preview,
  url,
  hasTitle,
  hasDescription,
  hasUrl,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor && data.template !== 'article'
        ? `bg-${backgroundColor}`
        : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div :class="['container', `container--${data?.template}`]">
      <div
        class="video"
        :class="[
          backgroundColor === 'black' && data.template !== 'article'
            ? `white`
            : '',
        ]"
      >
        <div v-if="hasTitle || hasDescription" class="video__top">
          <h2
            v-if="hasTitle"
            class="mb-0 video__title h2 text-center"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="title"
          ></h2>
          <div
            v-if="hasDescription"
            class="mb-0 video__description body-1-regular text-center"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="description"
          ></div>
        </div>
        <VideoPlayer
          v-if="hasUrl"
          :url="url"
          :preview="preview"
          :view="'default'"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.video {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__top {
    display: flex;
    flex-direction: column;
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
  }
  &__title {
    margin: 0;
    @include media-breakpoint-up(md) {
      max-width: 66.3%;
      margin: 0 auto;
    }
  }
  &__description {
    &:deep(p:last-child) {
      margin-bottom: 0;
    }
    @include media-breakpoint-up(md) {
      max-width: 66.3%;
      margin: 0 auto;
    }
  }
}
</style>
